import { SizeType } from '@/components/Slider';

export const homeBannerSize: SizeType = {
  width: 1120,
  height: 289,
};

export const loginBannerSize: SizeType = {
  width: 800,
  height: 428,
};

export const campaignBannerImageSize: SizeType = {
  width: 1180,
  height: 289,
};

export const campaignImageSize: SizeType = {
  width: 1120,
  height: 300,
};

export const partnerImageSize: SizeType = {
  width: 120,
  height: 120,
};
